// Central airlines manifest — used by the /transition hub page.
// This stays in sync with /app/frontend/src/data/airlines/index.js.
// Only airlines that have an actual landing page get listed.

export const AIRLINE_CATEGORIES = {
  lowcost: 'Low-cost & charters',
  legacy: 'Legacy / National carriers',
};

export const AIRLINE_DIRECTORY = [
  // ---------------- LOW-COST / CHARTERS ----------------
  {
    slug: 'ryanair',
    name: 'Ryanair',
    country: 'Ireland (intl. bases)',
    flag: '🇮🇪',
    category: 'lowcost',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'easyjet',
    name: 'easyJet',
    country: 'United Kingdom',
    flag: '🇬🇧',
    category: 'lowcost',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'wizz-air',
    name: 'Wizz Air',
    country: 'Eastern Europe',
    flag: '🇭🇺',
    category: 'lowcost',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'vueling',
    name: 'Vueling',
    country: 'Spain',
    flag: '🇪🇸',
    category: 'lowcost',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'transavia',
    name: 'Transavia',
    country: 'France · Netherlands',
    flag: '🇫🇷',
    category: 'lowcost',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'eurowings',
    name: 'Eurowings',
    country: 'Germany',
    flag: '🇩🇪',
    category: 'lowcost',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'volotea',
    name: 'Volotea',
    country: 'Spain · Italy',
    flag: '🇪🇸',
    category: 'lowcost',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'norwegian',
    name: 'Norwegian',
    country: 'Norway',
    flag: '🇳🇴',
    category: 'lowcost',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'jet2',
    name: 'Jet2',
    country: 'United Kingdom',
    flag: '🇬🇧',
    category: 'lowcost',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'pegasus',
    name: 'Pegasus',
    country: 'Türkiye',
    flag: '🇹🇷',
    category: 'lowcost',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'sunexpress',
    name: 'SunExpress',
    country: 'Germany · Türkiye',
    flag: '🇩🇪',
    category: 'lowcost',
    languages: ['en'],
    status: 'live',
  },

  // ---------------- LEGACY / NATIONAL CARRIERS ----------------
  {
    slug: 'air-france',
    name: 'Air France',
    country: 'France',
    flag: '🇫🇷',
    category: 'legacy',
    languages: ['en', 'fr'],
    status: 'live',
  },
  {
    slug: 'lufthansa',
    name: 'Lufthansa',
    country: 'Germany',
    flag: '🇩🇪',
    category: 'legacy',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'klm',
    name: 'KLM',
    country: 'Netherlands',
    flag: '🇳🇱',
    category: 'legacy',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'british-airways',
    name: 'British Airways',
    country: 'United Kingdom',
    flag: '🇬🇧',
    category: 'legacy',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'iberia',
    name: 'Iberia',
    country: 'Spain',
    flag: '🇪🇸',
    category: 'legacy',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'ita-airways',
    name: 'ITA Airways',
    country: 'Italy',
    flag: '🇮🇹',
    category: 'legacy',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'tap',
    name: 'TAP Air Portugal',
    country: 'Portugal',
    flag: '🇵🇹',
    category: 'legacy',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'sas',
    name: 'SAS',
    country: 'Scandinavia',
    flag: '🇸🇪',
    category: 'legacy',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'finnair',
    name: 'Finnair',
    country: 'Finland',
    flag: '🇫🇮',
    category: 'legacy',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'austrian',
    name: 'Austrian',
    country: 'Austria',
    flag: '🇦🇹',
    category: 'legacy',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'swiss',
    name: 'Swiss',
    country: 'Switzerland',
    flag: '🇨🇭',
    category: 'legacy',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'brussels-airlines',
    name: 'Brussels Airlines',
    country: 'Belgium',
    flag: '🇧🇪',
    category: 'legacy',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'lot',
    name: 'LOT Polish',
    country: 'Poland',
    flag: '🇵🇱',
    category: 'legacy',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'aegean',
    name: 'Aegean',
    country: 'Greece',
    flag: '🇬🇷',
    category: 'legacy',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'turkish-airlines',
    name: 'Turkish Airlines',
    country: 'Türkiye',
    flag: '🇹🇷',
    category: 'legacy',
    languages: ['en'],
    status: 'live',
  },
  {
    slug: 'aer-lingus',
    name: 'Aer Lingus',
    country: 'Ireland',
    flag: '🇮🇪',
    category: 'legacy',
    languages: ['en'],
    status: 'live',
  },
];
